import { PlatformLocation } from '@angular/common';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { environment } from '../shared/config/app-config';
import { ConformComponent } from '../conform/conform.component';
import { ShowHideInput, User, UserService } from '../shared';
import { SucesstempComponent } from '../sucesstemp/sucesstemp.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-changepwd',
    templateUrl: './changepwd.component.html',
    styleUrls: ['./changepwd.component.css']
})
export class ChangepwdComponent implements OnInit {
    clientlog: any;
    myDiv: any;
    openErroModel: any;
    modalRef: BsModalRef;
    @ViewChild(ShowHideInput) input: ShowHideInput;
    @ViewChild('erroModal') erroModal: ElementRef;
    respass: string;
    show = false;
    isSubmitting = false;
    public params: any;
    public pasd: any = {};
    newonepassword = '';
    newtwopassword = '';
    public apiurl: any = environment.api_url;
    errormsgpass = '';
    @ViewChild('popvaild') testModal: TemplateRef<any>;
    expires: MatDialogRef<ConformComponent>;
    i: number = 0;
    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
        this.movable()
    }
    constructor(
        private activeroute: ActivatedRoute,
        private routers: Router,
        private userservic: UserService,
        private modalService: BsModalService,
        private dialog: MatDialog,
        location: PlatformLocation,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang(userservic.defaultLang); 
        this.activeroute.params.subscribe(params => {
            this.params = params;
        });
        // location.onPopState(() => {
        //     //console.log('pressed back!');
        //     //alert("are you sure you want to exit?")
        //     if(this.i==0){
        //     var r = confirm("are you sure you want to exit?");

        //     if (r == true && this.i==0) {
        //         // Call Back button programmatically as per user confirmation.
        //        // history.back();
        //        this.i = this.i+1;
        //        this.routers.navigate(['/login']);
        //         // Uncomment below line to redirect to the previous page instead.
        //         // window.location = document.referrer // Note: IE11 is not supporting this.
        //     } else if(r == false && this.i==0) {
        //         // Stay on the current page.
        //         // history.pushState(null, null, window.location.pathname);
        //         // this.ngOnInit();
        //         // this.routers.navigate(['changepassword/'+ this.params]);
        //        // history.pushState(null, null, 'changepassword'+ this.params);
        //        this.i = this.i+1;
        //        history.forward();
        //         //return false;
        //         //return false
        //     }
        // }

        //  this.modalRef = this.modalService.show(ModalContentComponent,{class: 'modal-sm',backdrop: 'static'})

        //});


    }
    public imageURL: string = environment.cloudeImageURL;
    public currentUser: User;

    ngOnInit() {
        this.userservic.currentUser.subscribe(
            (userData) => {
                this.currentUser = userData;
                if (this.currentUser.item) {
                    if (this.currentUser.item.hostModel == "CLOUD")
                        this.imageURL = environment.cloudeImageURL;
                    else
                        this.imageURL = environment.vmImageURL;
                } else
                    this.imageURL = environment.cloudeImageURL;
            }
        )


        // //////console.log("params",this.params.name)

        this.userservic.getranidcheck(this.params.name)
            .subscribe(
                data => {
                    if (data && data.userInfo.status == "success") {
                        this.clientlog = data.userInfo.userImage;
                    } else {
                        this.respass = "Not a vaild ID & try again!!";
                        this.expires = this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
                        this.expires.componentInstance.message = 'Unauthorized Access';
                    }
                })
        // this.getlog()
    }


    getlog() {
        this.userservic.getclientlogo(this.params.name)
            .subscribe(
                data => {
                    this.clientlog = data.clientLogoPath;
                }
            )
    }

    toggleShow(event, id, inputid) {
        this.show = !this.show;

        if (this.show) {
            $(`#${id}`).removeClass('fa-eye')
            $(`#${id}`).addClass('fa-eye-slash')
            let input = $(`#${inputid}`);
            input.attr('type', 'text')
        }
        else {
            $(`#${id}`).removeClass('fa-eye-slash')
            $(`#${id}`).addClass('fa-eye')
            let input = $(`#${inputid}`);
            input.attr('type', 'password')

        }
    }
    openModalc(passcha) {
        //////console.log(passcha);
        this.modalRef = this.modalService.show(passcha, { class: 'modal-sm', backdrop: 'static' })
        this.movable()
    }

    passwordmatch(ed) {
        //////console.log('Valuessss:' , ed.value,this.pasd)
        if (ed.value.newonepassword == ed.value.newtwopassword) {
            this.userservic.updatepasschange(this.params.name, ed.value.newonepassword, ed.value.newtwopassword)
                .subscribe(
                    data => {
                        if (data.userInfo.status == "success") {
                            // this.userservic.logAudit('getUserPassWordUpdate',0).subscribe(data=>{})              
                            // ////console.log('Successfully passsword Updated');        
                            this.dialog.open(SucesstempComponent, { hasBackdrop: false });
                            this.errormsgpass = '';
                            if (navigator.userAgent.search("iPhone") != -1 && location.href.search("changepassword") == -1) {
                                window.open("https://apps.apple.com/us/app/rc-coach/id1475273242", '_blank')
                            }

                        } else {
                            this.errormsgpass = data.userInfo.message;


                        }
                    })

        }
        else {
            this.errormsgpass = "Password did not match, Please try again";

        }
    }
    movable() {
        $(function () {
            let modalContent: any = $('.modal-content');
            let modalHeader = $('.modal-header');
            modalHeader.addClass('cursor-all-scroll');
            modalContent.draggable({
                handle: '.modal-header'
            });
        });
    }
    getFullYear() {
        return new Date().getFullYear();
    }
}
